#@import CLNDR
#@import Booking.Presenters.Calendar
#@import Booking.Views.Base
#@export Booking.Views.Calendar

class Booking.Views.Calendar extends Booking.Views.Base

  presenter: Booking.Presenters.Calendar

  templateName: 'calendar'

  selectedClass: 'selected'

  previouslySelectedClass: 'previously-selected'

  constructor: ->
    Booking.Views.Base.apply this, arguments
    @collection.on 'sync', @setEvents, this

  setEvents: ->
    return if @model.isBookerDeal()
    @calendar?.setEvents @collection.toJSON() # Note: CLNDR::setEvents triggers rendering

  render: ->
    # Events were not being maintained correctly on re-render, so we need to manually remove and add them each time.
    if @calendar
      @$el.off()
      @calendar.bindEvents()
    else
      @calendar = @$el.clndr @CLNDRparams()
    # set month to current or earliest date
    this

  selectDate: (selection) ->
    if selection.events.length > 0 or @model.isBookerDeal()
      @markDates(selection.date)
      @trigger 'select', selection.date, this

  renderCalendar: (data) ->
    presenter = new @presenter
      model: @model
      calendarData: data
      collection: @collection

    @template().render presenter.toHashWithHelpers()

  CLNDRparams: ->
    timeMomentField = 'clndrTimeMoment'

    startWithMonth = @model.getSelectedDate() || @collection.first()?.get(timeMomentField)

    showAdjacentMonths: false
    dateParameter:      timeMomentField
    startWithMonth:     startWithMonth
    timezoneOffset:     @model.getTimezone()
    events:             @collection.toJSON()
    render:             _.bind @renderCalendar, this
    clickEvents:
      click:            _.bind @selectDate, this
      onMonthChange:    _.bind @changeMonth, this
    targets:
      nextButton:       'next'
      previousButton:   'previous'
      day:              'day'
      empty:            'unavailable'

  changeMonth: ->
    @model.resetDate()
    @fetchAvailabilityIfNeeded()
    @markDates @model.getSelectedDate()

  fetchAvailabilityIfNeeded: ->
    return if @model.isBookerDeal() or @collection.hasTimesInMonth(@calendar.month)
    @fetchAvailabilityForCurrentMonth()

  fetchAvailabilityForCurrentMonth: ->
    initialTime = moment(@calendar.month).startOf('month')
    finalTime = moment(@calendar.month).endOf('month')
    @$('.loading').show()
    alwaysCallback = =>
      @$('.loading').hide()

    @model.fetchAvailability(initialTime, finalTime, false, alwaysCallback)

  afterRender: ->
    @markDates @model.getSelectedDate()

  markDates: (selectedDate) ->
    @unselect()

    if not @model.isBookerDeal()
      @markDateAsSelected(date, @previouslySelectedClass) for date in @collection.getSelectedDates()

    @markDateAsSelected(selectedDate.format('YYYY-MM-DD'), @selectedClass) if selectedDate

  markDateAsSelected: (date, cssClass) ->
    @calendar.element.find(".calendar-day-#{date}").addClass(cssClass)

  unselect: ->
    @calendar.element.find(".#{@previouslySelectedClass}").removeClass(@previouslySelectedClass)
    @calendar.element.find(".#{@selectedClass}").removeClass(@selectedClass)
